import api from '../services/api';

interface UserExistsResponse {
  totalSize: number;
}

/**
 * Checks if a non-archived user with the given username exists within a specific schema.
 * Used before attempting to log in a user.
 * @param idToken string
 * @param schema string
 * @param username string
 * @returns A Promise that resolves to `true` if the user exists and is not archived,
 *          `false` otherwise. Returns `false` for API errors or if no user is found.
 */
export const checkUserExists = async (idToken: string, schema: string, username: string): Promise<boolean> => {
  try {
    const trimmedUsername = username.trim();

    const params = new URLSearchParams();
    params.append('filter', `archived:eq:false`);
    params.append('filter', `userId:eq:${trimmedUsername}`);
    params.append('pageSize', '0');

    const resp = await api<UserExistsResponse>(`users?${params}`, {
      headers: {
        authorization: `Bearer ${idToken}`,
        'myosh-schema': schema,
      },
    });

    return resp.totalSize > 0;
  } catch {
    return false;
  }
};
